import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/esm/Card'
import Controllers from '../../Api/Controllers'
import Slider from "react-slick";
import Helpers from '../../Components/Helpers/Helpers';
import ReactPlaceholder from 'react-placeholder/lib'
import Button from 'react-bootstrap/Button'
import CustomersEcommerceForm from './CustomersEcommerceForm';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { useHistory } from 'react-router-dom'
import Input from '../../Components/Form/Input';
import FormCustom from '../../Components/Form/FormCustom';
import { toast } from 'react-toastify';
import './EcommercePremium.scss';

function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        />
    );
}

const Ecommerce = _ => {
    const [readyAll, setReadyAll] = useState(false);
    const [clasifications, setClasifications] = useState([])
    const [readyProducts, setReadyProducts] = useState(false)
    const [clasificationSelected, setClasificationSelected] = useState('')
    const [productsByClasification, setProductsByClasification] = useState([])

    const [customersSelected, setCustomersSelected] = useState({})
    const [customersChange, setCustomersChange] = useState({})

    const [showFormCustomers, setShowFormCustomers] = useState(false)
    const [showCart, setShowCart] = useState(false)

    const history = useHistory()

    const [imagesBanner, setImagesBanner] = useState([])
    const [search, setSearch] = useState('');
    const [searched, setSearched] = useState('');

    const [firstLoad, setFirstLoad] = useState(false);

    useEffect(() => {
        Controllers.cart.create_cart_customers().then(() => setFirstLoad(true));
    }, [])

    useEffect(() => {
        if (!readyAll && firstLoad) {
            Promise.all([
                Controllers.cart.get_cart_customers(),
                Controllers.clasification.get_clasification_ecommerce(),
                Controllers.text.get_text_id({ p_id_text: 3 })
            ]).then(([
                resCart, resClasification, resText
            ]) => {
                setCustomersSelected(resCart.data)
                setCustomersChange(resCart.data)

                setClasifications(resClasification.data)
                setImagesBanner(resText.data)

                if (resClasification.data.length > 0) {
                    setClasificationSelected(resClasification.data[0].id_clasification)
                } else {
                    setReadyProducts(true)
                }

                setReadyAll(true);
            })
        }
    }, [readyAll, firstLoad])

    useEffect(() => {
        if (clasificationSelected && !readyProducts) {
            setReadyProducts(false)
            Controllers.product.get_product_by_customers({
                p_id_clasification: clasificationSelected
            }).then(res => {
                setProductsByClasification(res.data)
                setReadyProducts(true)
            })
        }
    }, [clasificationSelected, readyProducts])

    const products = useMemo(() => <ReactPlaceholder ready={readyProducts} showLoadingAnimation rows={25}>
        <Card className="shop-products-panel">
            <Card.Body className="pb-4" id="carousel_ecommerce">
                <div className="shop-section-heading">
                    <h3>Productos seleccionados</h3>
                    <span>Bienestar y oportunidad en una sola compra</span>
                </div>
                {searched !== '' && <div>
                    <small>Resultados Encontrados: <strong>{productsByClasification.length} Productos</strong></small>
                </div>}
                <Slider {...{
                    dots: false,
                    arrows: true,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    /* autoplay: true,
                    autoplaySpeed: 3000, */
                    nextArrow: <SampleNextArrow />,
                    prevArrow: <SampleNextArrow />,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                }}>
                    {React.Children.toArray([
                        ...productsByClasification,
                    ].map(r => {
                        return <div className={''}>
                            <div className="shop-product-wrap">
                                <div className="shop-product-card">
                                    <div className="shop-product-image">
                                        <img src={Helpers.config.resourcesUrl({ url: r.file_photo })} alt={r.description_store_product} />
                                    </div>
                                    <div className="shop-product-info">
                                        <div className="shop-product-name">{r.description_store_product}</div>
                                        <div className="shop-product-price">$ {r.price_product}</div>
                                        <div className="shop-product-meta"><span>{r.point_product} puntos</span><span>VN {r.value_business_product}</span></div>
                                            <Button className="shop-add-button" onClick={_ => {
                                                Controllers.cart.cart_det_insert_update({
                                                    p_id_product: r.id_product,
                                                    p_qty: 1,
                                                    p_price: r.price_product,
                                                    p_lot: '',
                                                    p_point: r.point_product,
                                                    p_value_business: r.value_business_product,
                                                }).then(_ => {
                                                    setShowCart(true)
                                                })
                                            }}>
                                                <i className="fa fa-shopping-cart mr-2"></i> Agregar al carrito
                                            </Button>
                                    </div>
                                </div>
                            </div>
                            <br /><br />
                        </div>
                    }))}
                </Slider>
            </Card.Body>
        </Card>
    </ReactPlaceholder>, [readyProducts, productsByClasification, searched])

    /* if (Helpers.date.get({ format: '%Y-%m-%d' }) >= '2023-12-01') {
        return ''
    } */

    return <>
        <div className="form-row ecommerce-premium">
            <div className="col-12 mb-4">
                <section className="shop-hero">
                    <span className="shop-eyebrow">System Devs · Marketplace</span>
                    <h2>Eleva tu bienestar.<br />Impulsa tu negocio.</h2>
                    <p>Descubre productos seleccionados para acompañar tu estilo de vida y hacer crecer tu comunidad.</p>
                    <div className="shop-benefits"><span className="shop-benefit"><i className="fa fa-shield-alt"></i> Compra protegida</span><span className="shop-benefit"><i className="fa fa-box-open"></i> Productos originales</span><span className="shop-benefit"><i className="fa fa-star"></i> Beneficios exclusivos</span></div>
                </section>
            </div>
            <div className="col-12 mb-4">
                <Card className="shop-toolbar">
                    <Card.Body>
                        <ReactPlaceholder ready={readyAll} showLoadingAnimation rows={1}>
                            <div className="d-flex flex-column flex-md-row justify-content-between">
                                <div className="d-flex flex-column flex-md-row align-self-start">
                                    <div className='align-self-center'><span className="shop-client-label">Cliente de la venta</span><strong className="shop-client-name">{customersSelected.id_customers_sale} · {customersSelected.full_name_customers}</strong></div>
                                    <Button size="sm" variant="secondary" className="ml-0 ml-md-2 mt-3 mt-md-0" onClick={_ => setShowFormCustomers(true)}>
                                        <i className="fa fa-edit mr-2"></i> Modificar Cliente
                                    </Button>
                                </div>
                                <div>
                                    <Button className="shop-cart-button mt-3 mt-md-0" onClick={_ => {
                                        history.push(Helpers.config.convertUrl({ url: '/carrito' }))
                                    }}>
                                        <i className="fa fa-shopping-cart mr-2"></i> Ir a Carrito
                                    </Button>
                                </div>
                            </div>
                        </ReactPlaceholder>
                    </Card.Body>
                </Card>
            </div>
            {showFormCustomers ? <>
                <div className="col-6">
                    <Card className="shop-search-panel">
                        <Card.Body>
                            <CustomersEcommerceForm customers={customersChange} reloadCustomers={_ => {
                                setReadyProducts(false);
                                setClasificationSelected(null)
                                setShowFormCustomers(false)
                                setReadyAll(false)
                            }} cancelCustomers={_ => setShowFormCustomers(false)} />
                        </Card.Body>
                    </Card>
                </div>
            </> : <>
                <div className="col-12">
                    <Card>
                        <Card.Body>
                            <Slider {...{
                                infinite: true,
                                speed: 500,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                autoplay: false,
                                autoplaySpeed: 3000
                            }}>
                                {React.Children.toArray(imagesBanner?.file_image_text?.map(b => <div className="d-flex justify-content-center" style={{
                                    outline: 'none',
                                }}>
                                    <img src={Helpers.config.resourcesUrl({ url: b })} alt="" className="img-fluid" style={{ maxHeight: 400, width: '90%', borderRadius: 10 }} />
                                </div>))}
                            </Slider>
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-12 mt-4">
                    <Card>
                        <Card.Body>
                            <FormCustom viewSubmit={false} onSubmit={() => {
                                if (search.trim() === '') {
                                    Helpers.toast.construct({
                                        response: 'warning',
                                        message: 'Ingrese un producto a buscar',
                                        toast
                                    });
                                    setSearch('');
                                    return;
                                }

                                setSearched(search);
                                setReadyProducts(false)
                                Controllers.product.search_product_by_customers({
                                    p_search: search
                                }).then(res => {
                                    setProductsByClasification(res.data)
                                    setReadyProducts(true)
                                })
                            }}>
                                <Input
                                    value={search}
                                    onChange={e => setSearch(e.currentTarget.value)}
                                    text="Buscar Producto"
                                    placeholder="Buscar Producto"
                                    style={{
                                        height: 40
                                    }}
                                    required
                                    append={[
                                        <Button type="submit">
                                            <i className='fa fa-search mr-2'></i>
                                            <span>Buscar</span>
                                        </Button>
                                    ]}
                                />
                            </FormCustom>
                            {searched !== '' && <div className='mt-3 d-flex'>
                                <small className='text-muted mr-2'>Producto Buscado:</small>
                                <div className='d-flex'>
                                    <div className='d-flex badge badge-secondary cur-pointer' onClick={() => {
                                        setSearched('');
                                        setSearch('');
                                    }}>
                                        <div className='mr-2 align-self-center'>{searched}</div>
                                        <div className='align-self-center'>
                                            <i className='fa fa-times'></i>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </Card.Body>
                    </Card>
                </div>
                {searched === '' && <div className="col-12 mt-4">
                    <div className="shop-categories">
                        {React.Children.toArray(clasifications.map(c => <div className={'shop-category ' + (parseInt(c.id_clasification) === parseInt(clasificationSelected) ? 'active' : '')} onClick={_ => {
                            setClasificationSelected(c.id_clasification)
                            setReadyProducts(false)
                        }}>
                            {c.name_clasification}
                        </div>))}
                    </div>
                </div>}
                <div className="col-12 mt-4">
                    {products}
                </div>
            </>}
        </div>
        <SweetAlert
            icon="shopping"
            show={showCart}
            showCancelButton
            title={<>Producto agregado al carrito</>}
            subtitle={<>¿Desea pagar ahora?</>}
            confirmButtonText="¡Sí, Pagar!"
            cancelButtonText="¡Seguir Comprando!"
            onCancel={() => setShowCart(false)}
            onConfirm={() => {
                history.push(Helpers.config.convertUrl({ url: '/carrito' }))
            }}
        />
    </>
}

export default Ecommerce
